import React, { useEffect, useState } from "react";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../../context/AuthContext";
import { isEmpty, isNumber } from "lodash";
import { toFixedWithoutRounding } from "../../../Utils/Toast";
import { Link, useLocation, useParams } from "react-router-dom";
import { apiGet } from "../../../Utils/apiFetch";
import apiPath from "../../../Utils/apiPath";
const HeaderWeb = () => {
  const [show, setShow] = useState(false);
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const userCoins = useContextSelector(AuthContext, (ctx) => ctx.userCoins);
  const { type } = useParams();
  const amounutRefresh = useContextSelector(
    AuthContext,
    (ctx) => ctx.amounutRefresh,
  );
  const refreshAmountLoader = useContextSelector(
    AuthContext,
    (ctx) => ctx.refreshAmountLoader,
  );
  const [count, setCount] = useState({
    cricketInplayCount: 0,
    soccerInplayCount: 0,
    tennisInplayCount: 0,
  });
  const inPlayCount = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.inPlayCountMobile,
      {
        type: "in_play",
      },
    );
    if (status === 200) {
      if (response_users.success) {
        if (response_users.results) {
          setCount(response_users.results);
        }
      }
    }
  };

  useEffect(() => {
    inPlayCount();
  }, []);
  const location = useLocation();
  let loc = location?.pathname?.split("/")[1];
  return (
    <div className="top">
      <div className="header full-wrap">
        <h1>
          <a href="/sports-sky">Mega Casino World</a>
        </h1>
        <ul className="account-wrap">
          <li className="main-wallet no-multi">
            <a className="a-wallet" href="#" id="multiWallet">
              {refreshAmountLoader ? (
                <p className="loading-bar" id="menuRefreshLoading">
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                </p>
              ) : (
                <ul id="accountCredit">
                  <li>
                    <span>Main Balance</span>{" "}
                    <span id="betCredit">
                      BDT{" "}
                      {isNumber(userCoins?.totalCoins)
                        ? toFixedWithoutRounding(userCoins?.totalCoins, 2)
                        : 0.0}
                    </span>
                  </li>
                  <li>
                    <span>Exposure</span>{" "}
                    <span style={{ color: "red" }} id="totalExposure">
                      ({toFixedWithoutRounding(userCoins?.exposure || 0, 2)})
                    </span>
                  </li>
                  <li className="nums">
                    +<span id="vendorQuantity">0</span>
                  </li>
                </ul>
              )}
            </a>
            <div
              onClick={amounutRefresh}
              className="a-refresh"
              href="#"
              id="menuRefresh"
              title="Refresh Main Wallet"
            >
              <img src={require("../../../assets/images/transparent.gif")} />
            </div>
          </li>
          <li className="account" style={{}}>
            <a
              onClick={() => setShow(!show)}
              id="accountPopup"
              style={{
                cursor: "pointer",
              }}
            >
              My Account
            </a>
            <ul
              id="account_pop"
              style={{
                display: show ? "block" : "none",
              }}
            >
              <li>
                <h4>
                  <span>{user?.user?.username}</span>
                </h4>
                <span className="gmt" title="Time Zone">
                  GMT+5:30
                </span>
              </li>
              <li>
                <Link to="/exchange/profile">My Profile</Link>
              </li>
              <li>
                <Link to="/exchange/balance-overview">Balance Overview</Link>
              </li>
              <li>
                <Link to="/exchange/account-statement">Account Statement</Link>
              </li>
              <li>
                <Link to="/exchange/my-bets">My Bets</Link>
              </li>
              <li>
                <Link to="/exchange/betting-history">Bets History</Link>
              </li>
              <li>
                <Link to="/exchange/profit-loss">Profit & Loss</Link>
              </li>
              <li>
                <Link to="/exchange/activity-log">Activity Log</Link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div className="menu-wrap">
        <div className="full-wrap">
          <ul className="menu" id="tabMenu">
            {" "}
            <li>
              <a href="/" id="menu_Home" neua="Home">
                Main
              </a>
            </li>
            <li>
              <Link
                to={"/sports-sky"}
                id="menu_Home"
                neua="Home"
                className={isEmpty(type) && loc == "sports-sky" ? "select" : ""}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/inplay-sky"
                id="menu_InPlay"
                neua="In-Play"
                className={loc == "inplay-sky" ? "select" : ""}
              >
                In-Play
              </Link>
            </li>
            <li>
              <Link
                to="/favourite-sky"
                id="menu_MultiMarkets"
                neua="Multi Markets"
                className={loc == "favourite-sky" ? "select" : ""}
              >
                Multi Markets
              </Link>
            </li>
            <li>
              <Link
                to="/sports-sky/cricket"
                id="menu_CRICKET"
                className={type == "cricket" ? "select" : ""}
              >
                <span id="tagLive" className="tag-live" style={{}}>
                  <strong />
                  {count?.cricketInplayCount}
                </span>
                Cricket
              </Link>
            </li>
            <li>
              <Link
                to="/sports-sky/soccer"
                id="menu_SOCCER"
                className={type == "soccer" ? "select" : ""}
              >
                <span id="tagLive" className="tag-live" style={{}}>
                  <strong />
                  {count?.soccerInplayCount}
                </span>
                Soccer
              </Link>
            </li>
            <li>
              <Link
                to="/sports-sky/tennis"
                id="menu_TENNIS"
                className={type == "tennis" ? "select" : ""}
              >
                <span id="tagLive" className="tag-live" style={{}}>
                  <strong />
                  {count?.tennisInplayCount}
                </span>
                Tennis
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HeaderWeb;
